import { readonly, ref } from 'vue'

export type Locale = 'de' | 'tr'

const de = {
  'language.choose': 'Sprache wählen',
  'meta.title': 'Hochzeit von {names}',
  'upload.heroEyebrow': 'Zur Hochzeit von',
  'upload.introTitle': 'Helft uns, diesen Tag festzuhalten',
  'upload.introText': 'Teilt eure Fotos & Videos direkt mit dem Brautpaar — sie landen im gemeinsamen Album.',
  'upload.successTitle': 'Vielen Dank!',
  'upload.successOne': 'Euer Beitrag ist im Album des Brautpaars angekommen.',
  'upload.successMany': '{count} Beiträge sind im Album des Brautpaars angekommen.',
  'upload.more': 'Weitere hochladen',
  'upload.pickerTitle': 'Fotos & Videos auswählen',
  'upload.pickerHint': 'Mehrere auf einmal möglich · direkt von der Kamera oder Galerie',
  'upload.selectedFiles': 'Ausgewählte Dateien',
  'upload.removeFile': '{name} entfernen',
  'upload.processing': 'Verarbeitung …',
  'upload.retry': 'Erneut versuchen',
  'upload.namePlaceholder': 'Euer Name (optional)',
  'upload.messagePlaceholder': 'Eine kleine Nachricht an das Brautpaar … (optional)',
  'upload.safeProcessing': 'Sichere Verarbeitung ohne Standortdaten …',
  'upload.keepOpen': 'Upload läuft — bitte lasst diese Seite geöffnet.',
  'upload.coupleOnly': 'Für das Brautpaar:',
  'upload.toAlbum': 'zum Album',
  'upload.submitProcessing': 'Beiträge werden verarbeitet …',
  'upload.submitUploading': 'Hochladen … {progress} %',
  'upload.submitEmpty': 'Erst Fotos oder Videos auswählen',
  'upload.submitOne': '1 Beitrag hochladen',
  'upload.submitMany': '{count} Beiträge hochladen',
  'upload.maxFiles': 'Ihr könnt höchstens {count} Dateien auf einmal auswählen.',
  'upload.unsupportedType': '{name} hat einen nicht unterstützten Dateityp.',
  'upload.fileTooLarge': '{name} ist zu groß. Fotos dürfen höchstens {imageLimit}, Videos höchstens {videoLimit} groß sein.',
  'upload.batchTooLarge': 'Die Auswahl ist insgesamt zu groß. Bitte ladet höchstens {limit} auf einmal hoch.',
  'upload.connectionLost': 'Die Verbindung wurde unterbrochen.',
  'upload.aborted': 'Der Upload wurde abgebrochen.',
  'upload.storageRejected': 'Der Speicher hat den Upload abgelehnt ({status}).',
  'upload.noChecksum': 'Der Speicher hat keine Prüfsumme zurückgegeben. Bitte prüft die S3-CORS-Einstellungen.',
  'upload.prepareFailed': 'Der Upload konnte nicht vorbereitet werden.',
  'upload.failed': 'Der Upload ist fehlgeschlagen.',
  'upload.partialFailure': '{completed} Beiträge sind angekommen. {failed} konnten nicht hochgeladen werden — bitte versucht es erneut.',
  'upload.completeFailure': 'Der Upload konnte nicht abgeschlossen werden. Bitte prüft eure Verbindung und versucht es erneut.',
  'upload.startFailure': 'Der Upload konnte nicht gestartet werden.',
  'album.yours': 'Euer Album',
  'album.opening': 'Das Album wird geöffnet …',
  'album.coupleOnly': 'Nur für das Brautpaar — bitte PIN eingeben',
  'album.pinLabel': 'Album-PIN',
  'album.unlocking': 'Wird geöffnet …',
  'album.unlock': 'Öffnen',
  'album.backToUpload': '← zurück zur Upload-Seite',
  'album.eyebrow': 'Das Album von',
  'album.views': 'Albumansichten',
  'album.album': 'Album',
  'album.guestbook': 'Gästebuch',
  'album.reload': 'Erneut laden',
  'album.loadingMemories': 'Eure Erinnerungen werden geladen …',
  'album.mediaSection': 'Foto- und Videoalbum',
  'album.filters': 'Album filtern',
  'album.all': 'Alle',
  'album.photos': 'Fotos',
  'album.videos': 'Videos',
  'album.withName': 'Mit Name',
  'album.withMessage': 'Mit Nachricht',
  'album.filterPerson': 'Nach Person filtern',
  'album.allPeople': 'Alle Personen',
  'album.newest': 'Neueste zuerst',
  'album.oldest': 'Älteste zuerst',
  'album.slideshow': 'Diashow',
  'album.downloadAll': 'Alle herunterladen',
  'album.emptySelection': 'Noch keine Beiträge in dieser Auswahl.',
  'album.openContribution': 'Beitrag von {name} öffnen',
  'album.anonymous': 'Anonymer Gast',
  'album.weddingPhoto': 'Hochzeitsfoto',
  'album.weddingVideoPreview': 'Vorschaubild eines Hochzeitsvideos',
  'album.guestbookEmpty': 'Noch keine Nachrichten im Gästebuch.',
  'album.guestbookThumbnail': 'Vorschaubild zum Gästebucheintrag',
  'album.backToGuestPage': '← zur Gäste-Seite',
  'album.viewPoster': 'QR-Plakat ansehen',
  'album.stats': '{contributions} Beiträge · {photos} Fotos · {videos} Videos · {guests} Gäste mit Namen',
  'album.unreachable': 'Das Album ist gerade nicht erreichbar. Bitte versucht es erneut.',
  'album.wrongPin': 'Falsche PIN — bitte erneut versuchen.',
  'album.loadFailed': 'Das Album konnte nicht geladen werden.',
  'album.select': 'Auswählen',
  'album.cancel': 'Abbrechen',
  'album.selectAll': 'Alle auswählen',
  'album.deselectAll': 'Auswahl aufheben',
  'album.selectItems': 'Beiträge auswählen',
  'album.selectedOne': '1 Beitrag ausgewählt',
  'album.selectedMany': '{count} Beiträge ausgewählt',
  'album.selectHint': 'Tipp: Ein Foto gedrückt halten und über weitere ziehen, um mehrere auszuwählen.',
  'album.selectContribution': 'Beitrag von {name} auswählen',
  'album.downloadSelected': 'Herunterladen',
  'album.downloadSelectedLabel': 'Ausgewählte Beiträge herunterladen',
  'album.shareSelected': 'Teilen',
  'album.shareSelectedLabel': 'Ausgewählte Beiträge teilen oder in Fotos speichern',
  'album.sharePreparing': 'Wird vorbereitet … {done}/{total}',
  'album.shareTooMany': 'Zum Teilen bitte höchstens {count} Beiträge auswählen – größere Auswahlen werden als ZIP heruntergeladen.',
  'album.shareFallback': 'Teilen war nicht möglich – die Auswahl wird stattdessen heruntergeladen.',
  'lightbox.dialog': 'Beitrag in Großansicht',
  'lightbox.photoAlt': 'Hochzeitsfoto in Großansicht',
  'lightbox.slideshow': 'Diashow · 4 Sek.',
  'lightbox.previous': 'Vorheriger Beitrag',
  'lightbox.close': 'Schließen',
  'lightbox.next': 'Nächster Beitrag',
  'lightbox.download': 'Herunterladen',
  'lightbox.downloadLabel': 'Diesen Beitrag als Datei herunterladen',
  'lightbox.share': 'Teilen & speichern',
  'lightbox.shareLabel': 'Diesen Beitrag teilen oder in Fotos speichern',
  'lightbox.sharePreparing': 'Wird vorbereitet …',
  'lightbox.shareFallback': 'Teilen war nicht möglich – die Datei wird stattdessen heruntergeladen.',
  'poster.settings': 'Druckeinstellungen',
  'poster.format': 'Plakatformat',
  'poster.print': 'Plakat drucken',
  'poster.eyebrow': 'Hochzeit von',
  'poster.title': 'Helft uns, diesen Tag festzuhalten',
  'poster.qrAlt': 'QR-Code zur Upload-Seite',
  'poster.qrLoading': 'QR-Code wird erstellt …',
  'poster.instructions': 'Scannen & eure Fotos und Videos mit dem Brautpaar teilen',
  'poster.footer': 'Zum Ausdrucken einfach diese Ansicht drucken',
  'poster.back': 'zurück zum Album',
  'api.pin': 'Falsche PIN — bitte erneut versuchen.',
  'api.rateLimit': 'Zu viele Versuche. Bitte wartet einen Moment und versucht es erneut.',
  'api.uploadPrepare': 'Der Upload konnte nicht vorbereitet werden. Bitte versucht es erneut.',
  'api.processing': 'Die Datei konnte nicht verarbeitet werden. Bitte versucht es mit einer anderen Datei erneut.',
  'api.generic': 'Die Anfrage konnte nicht abgeschlossen werden. Bitte versucht es erneut.',
} as const

type TranslationKey = keyof typeof de

const tr: Record<TranslationKey, string> = {
  'language.choose': 'Dil seçin',
  'meta.title': '{names} Düğünü',
  'upload.heroEyebrow': 'Düğünümüze hoş geldiniz',
  'upload.introTitle': 'Bu güzel günü birlikte ölümsüzleştirelim',
  'upload.introText': 'Fotoğraf ve videolarınızı bizimle paylaşın — hepsi ortak albümümüzde bir araya gelsin.',
  'upload.successTitle': 'Çok teşekkürler!',
  'upload.successOne': 'Paylaşımınız düğün albümümüze eklendi.',
  'upload.successMany': '{count} paylaşımınız düğün albümümüze eklendi.',
  'upload.more': 'Daha fazla yükle',
  'upload.pickerTitle': 'Fotoğraf ve video seçin',
  'upload.pickerHint': 'Aynı anda birden fazla dosya · kameradan veya galeriden',
  'upload.selectedFiles': 'Seçilen dosyalar',
  'upload.removeFile': '{name} dosyasını kaldır',
  'upload.processing': 'İşleniyor …',
  'upload.retry': 'Tekrar deneyin',
  'upload.namePlaceholder': 'Adınız (isteğe bağlı)',
  'upload.messagePlaceholder': 'Bize küçük bir not bırakın … (isteğe bağlı)',
  'upload.safeProcessing': 'Konum bilgileri kaldırılarak güvenle işleniyor …',
  'upload.keepOpen': 'Yükleme devam ediyor — lütfen bu sayfayı açık tutun.',
  'upload.coupleOnly': 'Gelin ve damat için:',
  'upload.toAlbum': 'albüme git',
  'upload.submitProcessing': 'Dosyalar işleniyor …',
  'upload.submitUploading': 'Yükleniyor … %{progress}',
  'upload.submitEmpty': 'Önce fotoğraf veya video seçin',
  'upload.submitOne': '1 dosyayı yükle',
  'upload.submitMany': '{count} dosyayı yükle',
  'upload.maxFiles': 'Aynı anda en fazla {count} dosya seçebilirsiniz.',
  'upload.unsupportedType': '{name} desteklenmeyen bir dosya türü.',
  'upload.fileTooLarge': '{name} çok büyük. Fotoğraflar en fazla {imageLimit}, videolar en fazla {videoLimit} olabilir.',
  'upload.batchTooLarge': 'Seçimin toplam boyutu çok büyük. Lütfen tek seferde en fazla {limit} yükleyin.',
  'upload.connectionLost': 'Bağlantı kesildi.',
  'upload.aborted': 'Yükleme iptal edildi.',
  'upload.storageRejected': 'Depolama hizmeti yüklemeyi reddetti ({status}).',
  'upload.noChecksum': 'Depolama hizmeti doğrulama bilgisini döndürmedi. Lütfen S3 CORS ayarlarını kontrol edin.',
  'upload.prepareFailed': 'Yükleme hazırlanamadı.',
  'upload.failed': 'Yükleme başarısız oldu.',
  'upload.partialFailure': '{completed} dosya yüklendi. {failed} dosya yüklenemedi — lütfen tekrar deneyin.',
  'upload.completeFailure': 'Yükleme tamamlanamadı. Lütfen internet bağlantınızı kontrol edip tekrar deneyin.',
  'upload.startFailure': 'Yükleme başlatılamadı.',
  'album.yours': 'Albümünüz',
  'album.opening': 'Albüm açılıyor …',
  'album.coupleOnly': 'Yalnızca gelin ve damat için — lütfen PIN’i girin',
  'album.pinLabel': 'Albüm PIN’i',
  'album.unlocking': 'Açılıyor …',
  'album.unlock': 'Aç',
  'album.backToUpload': '← yükleme sayfasına dön',
  'album.eyebrow': 'Düğün albümü',
  'album.views': 'Albüm görünümleri',
  'album.album': 'Albüm',
  'album.guestbook': 'Anı Defteri',
  'album.reload': 'Tekrar dene',
  'album.loadingMemories': 'Anılarınız yükleniyor …',
  'album.mediaSection': 'Fotoğraf ve video albümü',
  'album.filters': 'Albümü filtrele',
  'album.all': 'Tümü',
  'album.photos': 'Fotoğraflar',
  'album.videos': 'Videolar',
  'album.withName': 'İsimli',
  'album.withMessage': 'Mesajlı',
  'album.filterPerson': 'Kişiye göre filtrele',
  'album.allPeople': 'Tüm kişiler',
  'album.newest': 'En yeniler önce',
  'album.oldest': 'En eskiler önce',
  'album.slideshow': 'Slayt gösterisi',
  'album.downloadAll': 'Tümünü indir',
  'album.emptySelection': 'Bu seçimde henüz paylaşım yok.',
  'album.openContribution': 'Paylaşımı aç: {name}',
  'album.anonymous': 'İsimsiz misafir',
  'album.weddingPhoto': 'Düğün fotoğrafı',
  'album.weddingVideoPreview': 'Düğün videosu önizlemesi',
  'album.guestbookEmpty': 'Anı defterinde henüz mesaj yok.',
  'album.guestbookThumbnail': 'Anı defteri kaydının önizlemesi',
  'album.backToGuestPage': '← misafir sayfasına dön',
  'album.viewPoster': 'QR posterini görüntüle',
  'album.stats': '{contributions} paylaşım · {photos} fotoğraf · {videos} video · adı belirtilen {guests} misafir',
  'album.unreachable': 'Albüme şu anda ulaşılamıyor. Lütfen tekrar deneyin.',
  'album.wrongPin': 'PIN yanlış — lütfen tekrar deneyin.',
  'album.loadFailed': 'Albüm yüklenemedi.',
  'album.select': 'Seç',
  'album.cancel': 'Vazgeç',
  'album.selectAll': 'Tümünü seç',
  'album.deselectAll': 'Seçimi kaldır',
  'album.selectItems': 'Paylaşım seçin',
  'album.selectedOne': '1 paylaşım seçildi',
  'album.selectedMany': '{count} paylaşım seçildi',
  'album.selectHint': 'İpucu: Birden fazla seçmek için bir fotoğrafa basılı tutun ve diğerlerinin üzerinden sürükleyin.',
  'album.selectContribution': 'Paylaşımı seç: {name}',
  'album.downloadSelected': 'İndir',
  'album.downloadSelectedLabel': 'Seçilen paylaşımları indir',
  'album.shareSelected': 'Paylaş',
  'album.shareSelectedLabel': 'Seçilen paylaşımları paylaş veya Fotoğraflar’a kaydet',
  'album.sharePreparing': 'Hazırlanıyor … {done}/{total}',
  'album.shareTooMany': 'Paylaşmak için en fazla {count} paylaşım seçin – daha büyük seçimler ZIP olarak indirilir.',
  'album.shareFallback': 'Paylaşım yapılamadı – seçim bunun yerine indiriliyor.',
  'lightbox.dialog': 'Paylaşımın büyük görünümü',
  'lightbox.photoAlt': 'Düğün fotoğrafının büyük görünümü',
  'lightbox.slideshow': 'Slayt · 4 sn.',
  'lightbox.previous': 'Önceki paylaşım',
  'lightbox.close': 'Kapat',
  'lightbox.next': 'Sonraki paylaşım',
  'lightbox.download': 'İndir',
  'lightbox.downloadLabel': 'Bu paylaşımı dosya olarak indir',
  'lightbox.share': 'Paylaş & kaydet',
  'lightbox.shareLabel': 'Bu paylaşımı paylaş veya Fotoğraflar’a kaydet',
  'lightbox.sharePreparing': 'Hazırlanıyor …',
  'lightbox.shareFallback': 'Paylaşım yapılamadı – dosya bunun yerine indiriliyor.',
  'poster.settings': 'Baskı ayarları',
  'poster.format': 'Poster boyutu',
  'poster.print': 'Posteri yazdır',
  'poster.eyebrow': 'Düğünümüz',
  'poster.title': 'Bu güzel günü birlikte ölümsüzleştirelim',
  'poster.qrAlt': 'Yükleme sayfasına yönlendiren QR kodu',
  'poster.qrLoading': 'QR kodu oluşturuluyor …',
  'poster.instructions': 'QR kodunu tarayın, fotoğraf ve videolarınızı bizimle paylaşın',
  'poster.footer': 'Bu posteri yazdırmak için sayfayı yazdırmanız yeterli',
  'poster.back': 'albüme dön',
  'api.pin': 'PIN yanlış — lütfen tekrar deneyin.',
  'api.rateLimit': 'Çok fazla deneme yapıldı. Lütfen biraz bekleyip tekrar deneyin.',
  'api.uploadPrepare': 'Yükleme hazırlanamadı. Lütfen tekrar deneyin.',
  'api.processing': 'Dosya işlenemedi. Lütfen farklı bir dosyayla tekrar deneyin.',
  'api.generic': 'İstek tamamlanamadı. Lütfen tekrar deneyin.',
}

function supportedLocale(value: string | null | undefined): Locale | null {
  const language = value?.trim().toLowerCase().split(/[-_]/)[0]
  return language === 'de' || language === 'tr' ? language : null
}

function detectLocale(): Locale {
  if (typeof window === 'undefined') return 'de'
  const queryLocale = supportedLocale(new URLSearchParams(window.location.search).get('lang'))
  if (queryLocale) return queryLocale
  try {
    const storedLocale = supportedLocale(window.localStorage.getItem('wedding-language'))
    if (storedLocale) return storedLocale
  } catch {
    // Storage can be unavailable in privacy-focused browsers.
  }
  for (const language of navigator.languages?.length ? navigator.languages : [navigator.language]) {
    const detected = supportedLocale(language)
    if (detected) return detected
  }
  return 'de'
}

const localeState = ref<Locale>(detectLocale())

function applyDocumentLanguage() {
  if (typeof document !== 'undefined') document.documentElement.lang = localeState.value
}

applyDocumentLanguage()

export const locale = readonly(localeState)

export function setLocale(nextLocale: Locale) {
  localeState.value = nextLocale
  applyDocumentLanguage()
  try {
    window.localStorage.setItem('wedding-language', nextLocale)
  } catch {
    // The selection remains active for this page even without storage.
  }
}

export function t(key: TranslationKey, values: Record<string, string | number> = {}) {
  const message = (localeState.value === 'tr' ? tr : de)[key]
  return message.replace(/\{(\w+)\}/g, (match, name: string) => values[name] === undefined ? match : String(values[name]))
}

export function formatDateTime(value: string) {
  const formatted = new Date(value).toLocaleString(localeState.value === 'tr' ? 'tr-TR' : 'de-DE', {
    day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit',
  })
  return localeState.value === 'de' ? `${formatted} Uhr` : formatted
}

export function formatWeddingDate(isoDate: string | undefined, fallback: string) {
  if (!isoDate || !/^\d{4}-\d{2}-\d{2}$/.test(isoDate)) return fallback
  const [year, month, day] = isoDate.split('-').map(Number)
  return new Intl.DateTimeFormat(localeState.value === 'tr' ? 'tr-TR' : 'de-DE', {
    day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC',
  }).format(new Date(Date.UTC(year, month - 1, day)))
}

export function localizedApiError(path: string, status: number, fallback: string) {
  if (localeState.value === 'de') return fallback
  if (path.includes('/api/auth/pin') && status === 401) return t('api.pin')
  if (status === 429) return t('api.rateLimit')
  if (path.includes('/api/uploads/prepare')) return t('api.uploadPrepare')
  if (path.includes('/api/uploads/complete')) return t('api.processing')
  return t('api.generic')
}
